module.exports = __webpack_public_path__ + "static/media/arrowdownwardRed.d5ffec7a.svg";